import React from "react";
import { Users, Zap, CheckCircle } from "lucide-react";

const WhyChooseSurveysiq = () => {
  const steps = [
    {
      id: 1,
      title: "10K+ Active Respondents",
      description:
        "Instant access to a large and diverse audience ready to provide valuable feedback for your business decisions.",
      icon: <Users className="text-black text-3xl" />,
    },
    {
      id: 2,
      title: "Fast & Simple Setup",
      description:
        "Create and launch surveys in just minutes with our intuitive drag-and-drop builder and pre-made templates.",
      icon: <Zap className="text-black text-3xl" />,
    },
    {
      id: 3,
      title: "Accurate & Transparent Data",
      description:
        "Get reliable insights with detailed reporting and analytics from real users who are incentivized to provide honest feedback.",
      icon: <CheckCircle className="text-black text-3xl" />,
    },
  ];

  return (
    <section className="py-12 px-4 sm:px-6 lg:px-8 bg-gray-50 font-sans">
      <div className="max-w-90vw mx-auto">
        <h2 className="text-4xl font-bold text-center text-gray-800 mb-6">
          Why Choose SurveysIQ
        </h2>
        <div className="text-center max-w-[600px] mb-10 text-xl text-gray-500 mx-auto">
          <p>
            Join thousands of companies already using SurveysIQ to make smarter
            business decisions
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step) => (
            <div
              key={step.id}
              className="flex flex-col items-center bg-blue-50 rounded-lg shadow-lg p-6 text-center space-y-4"
            >
              <div className="flex items-center justify-center h-16 w-16 rounded-full bg-green-600 shadow-inner">
                {step.icon}
              </div>
              <h3 className="text-xl font-semibold text-gray-800">
                {step.title}
              </h3>
              <p className="text-gray-500">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSurveysiq;
